






























































import Vue from 'vue'
import { ValuationConcept } from '@/interfaces/valuation/ValuationRecord'
import { ValuationRecordsPagination } from '@/types/store/valuation'
import client from '@/services/api/client'
import { MessageType } from '../../interfaces/app/Message'

export default Vue.extend({
  created() {
    this.$store.dispatch('valuationRecords/fetchConcepts')
  },
  computed: {
    concepts(): ValuationConcept[] {
      return this.$store.getters['valuationRecords/concepts']
    },
    pagination(): ValuationRecordsPagination {
      return this.$store.getters['valuationRecords/conceptPagination']
    },
    currentPage: {
      get(): number {
        return this.pagination.current
      },
      set(val: number): void {
        this.$store.dispatch('valuationRecords/changeConceptPage', val)
      },
    },
    perPage: {
      get(): number {
        return this.pagination.perPage
      },
      set(val: number): void {
        this.$store.dispatch('valuationRecords/changeConceptPerPage', val)
      },
    },
  },
  methods: {
    deleteConcept(id: number) {
      this.$store.commit('app/setLoading', true)
      client({
        url: `/v1/concept/${id}`,
        method: 'DELETE',
      })
        .then(response => {
          const message = this.$createMessage('Koncept byl smazán')
          this.$store.dispatch('app/addTempMessage', { message })
          this.$store.dispatch('valuationRecords/fetchConcepts')
        })
        .catch(err => {
          const message = this.$createMessage(
            'Koncept se nepodařilo smazat',
            MessageType.Error
          )
          this.$store.dispatch('app/addTempMessage', { message })
        })
        .finally(() => this.$store.commit('app/setLoading', false))
    },
  },
})
